var exports = {
  "Y": "Page__18oD5b",
};

module.exports = exports;
